<template>
  <div class="minicart" v-bind:class="{
    'is-loading': !minicartLoaded,
    'minicart--black-friday': isBlackFriday
    }">
    <div class="minicart__head">

      <p class="minicart__head__content" >
        <strong>
          <i
            class="fa fa-refresh fa-spin mr-2"
            aria-hidden="true"
            v-if="!minicartLoaded && minicart"></i>
          <span
            v-text="
              (minicart ? minicart.count : 0) +
              ' ' +
              ((minicart?.count ?? 0) == 1 ? 'produto' : 'produtos') +
              ' no carrinho'
            "></span>
          <span v-if="minicart" class="item-quantity color-primary">
            ({{ totalNumberOfItems }}
            {{ totalNumberOfItems === 1 ? "item" : "itens" }})</span>
        </strong>

        <button v-if="minicart" v-on:click="cleanCart()" class="clear-cart">
          Limpar carrinho
        </button>
      </p>
    </div>

    <div class="minicart__empty-state" v-if="!minicart || minicart.count == 0">
      <div class="minicart__empty-state__figure">
        <div class="minicart__empty-state__figure__icon"></div>
      </div>
      <div class="minicart__empty-state__title">
        Seu carrinho está vazio
      </div>
    </div>

    <div class="minicart__list" v-if="minicart && minicart.count > 0">
      <div class="minicart__item minicart__item--header">
        <div>Loteria</div>
        <div>Tipo</div>
        <div>Qtd</div>
        <div>Valor</div>
        <div></div>
      </div>

      <div
        class="minicart__item"
        v-for="(item, index) in minicart.items"
        :key="index">
        <div>
          <div
            class="minicart__item__lottey-name"
            v-bind:class="
              'minicart__item__lottey-name--' + getLotoSlug(item.lotteryID)
            "
            v-text="item.lotteryName"></div>
          <div v-if="item.categoryID == '1'" v-text="item.productName"></div>
        </div>
        <div v-text="item.categoryID == '1' ? 'Bolão' : 'Seu Jogo'"></div>

        <div
          class="
            form-control form-control-select form-control-small
            d-inline-block
          ">
          <select
            v-model="item.unitsAcquired"
            :disabled="item.categoryID === 2"
            v-on:change="
              updateUnits(item.shoppingCartItemID, item.unitsAcquired)
            ">
            <template v-for="(unit, index) in item.unitsInStock">
              <option :value="unit" v-bind:key="index">
                {{ "x" + unit }}
              </option>
            </template>
          </select>
        </div>

        <div class="color-primary" v-text="intToReal(item.total)"></div>
        <div>
          <button v-on:click="removeItemCart(item.shoppingCartItemID)">
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="minicart__bf-promo" v-if="isBlackFriday && (!minicart || minicart.count == 0)">
      <div class="minicart__bf-promo__title">Não perca tempo, aproveite!</div>
      <div class="minicart__bf-promo__content">
        <div class="minicart__bf-promo__description">
          Comprando 2 ou mais cotas de um bolão você ganha um desconto progressivo nas suas compras
        </div>
        <div class="minicart__bf-promo__icon"></div>
      </div>
    </div>

    <div
      class="minicart__footer"
      :class="{ 'minicart__footer--black-friday' : isBlackFriday }"
      v-if="minicart && minicart.count > 0">
      <div class="minicart__footer__total">
        <div class="minicart__footer__total__label">Total</div>
        <div
          class="minicart__footer__total__value"
          :class="{ 'minicart__footer__total__value--discount' : isBlackFriday && minicart.discountAmount }"
        >
          <span v-text="intToReal(minicart.total)"></span>
        </div>
        <div class="minicart__footer__discount-amount" v-if="isBlackFriday" :class="{ 'minicart__footer__discount-amount--applied' : minicart.discountAmount }">
          <span class="minicart__footer__total__label">Total com desconto:</span>
          <strong class="minicart__footer__total__value">
            <span>{{ intToReal(minicart.total - minicart.discountAmount) }}</span>
          </strong>
        </div>
      </div>
      <a
        href="/carrinho"
        class="btn btn-block btn-square btn-success text-uppercase"
      >
        Seguir para pagamento
      </a>

      <div class="minicart__footer__discount" v-if="isBlackFriday">
        <ul class="minicart__footer__discount__list-bar">
          <li
            v-for="discountItem in discountList"
            class="minicart__footer__discount__list-bar__percent"
            :class="{ 'minicart__footer__discount__list-bar__percent--active' : minicart.discountAmount && discountItem.id <= minicart.appliedDiscount.discountID }"
            :key="`discount-item-${discountItem.id}`"
          >
            <div class="minicart__footer__discount__list-bar__percent__label">desconto {{ discountItem.discount }}%</div>
            <div class="minicart__footer__discount__list-bar__percent__bar"></div>
          </li>
        </ul>
        <!-- <div class="minicart__footer__discount__description">
          <div class="minicart__footer__discount__description__icon"></div>
          Adicione mais 2 cotas para desconto de 10%
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import getLotById from '@helpers/getLotById';
import intToReal from '@helpers/intToReal';
const CartApi = require('../Api/CartApi').default;

export default {
  props: {
    onClose: null
  },
  data: function () {
    return {
      isBlackFriday: false,
      minicart: null,
      shoppingCartItemID: null,
      minicartLoaded: false,
      totalNumberOfItems: 0,
      discountList: [
        {
          id: 1,
          discount: 5
        },
        {
          id: 2,
          discount: 10
        },
        {
          id: 3,
          discount: 15
        }
      ]
    };
  },
  methods: {
    intToReal: intToReal,
    fetchInfo: function () {
      const _self = this;

      this.minicartLoaded = false;

      CartApi.getItems()
        .then((res) => {
          if (res) {
            _self.minicart = res;
            // _self.isBlackFriday = new Date() < new Date('11-21-23');

            const product =
              _self.minicart &&
              _self.minicart.items.length &&
              _self.minicart.items[0];

            _self.shoppingCartItemID = product && product.shoppingCartItemID;
            _self.minicart.discountAmount = this.calcDiscountAmount();
          }
        })
        .catch((res) => {
          console.error(res);
        })
        .then(() => {
          _self.totalNumberOfItems = _self.getTotalNumberOfItems();
          _self.minicartLoaded = true;
        });
    },
    removeItemCart: function (id) {
      const confirm = window.confirm('Tem certeza que deseja remover este item?');
      if (!confirm) {
        return;
      }

      const _self = this;
      _self.minicartLoaded = false;

      CartApi.delete(id, true, _self.minicart.items)
        .then(() => {
          Vue.$toast.open({
            position: window.innerWidth <= 992 ? 'top' : 'bottom-right',
            message: 'Item removido sucesso!'
          });
        })
        .catch(() => {
          Vue.$toast.open({
            position: window.innerWidth <= 992 ? 'top' : 'bottom-right',
            type: 'error',
            message: 'Erro ao tentar remover o item.'
          });
        })
        .then(() => {
          this.minicartLoaded = true;
        });
    },
    cleanCart: function () {
      const _self = this;

      CartApi.empty(_self.shoppingCartItemID)
        .then(() => {
          this.$emit('on-close');

          Vue.$toast.open({
            message: 'Carrinho esvaziado com sucesso!'
          });
        })
        .catch(() => {
          Vue.$toast.open({
            position: window.innerWidth <= 992 ? 'top' : 'bottom-right',
            type: 'error',
            message: 'Erro ao tentar remover esvaziar carrinho.'
          });
        })
        .finally(() => (this.minicartLoaded = true));
    },
    getLotoSlug: function (lotoId) {
      const lotoInfo = getLotById(lotoId);
      return lotoInfo ? lotoInfo.slug : '';
    },
    getTotalNumberOfItems () {
      let amount = 0;

      if (!this.minicart) {
        return;
      }

      this.minicart.items.forEach((item) => {
        amount += item.unitsAcquired;
      });
      return amount;
    },
    updateUnits (itemId, units) {
      const bet = this.minicart.items.find((a) => a.shoppingCartItemID == itemId);

      if (!bet || bet.categoryID !== 1) {
        return;
      }

      const _self = this;
      _self.minicartIsLoading = true;

      CartApi.update(itemId, units, true, bet.lotteryID)
        .then(function () {
          Vue.$toast.open({
            position: window.innerWidth <= 992 ? 'top' : 'bottom-right',
            message: 'Apostas atualizadas!'
          });
        })
        .catch(function () {
          Vue.$toast.open({
            type: 'error',
            position: window.innerWidth <= 992 ? 'top' : 'bottom-right',
            message: 'Erro ao executar.'
          });
          _self.minicartIsLoading = false;
        });
    },
    calcDiscountAmount: function () {
      if (!this.minicart || !this.minicart.appliedDiscount) {
        return 0;
      }

      const unitsAcquired = this.minicart.items
        .filter(item => item.categoryID == '1')
        .reduce((previous, current) => current.unitsAcquired + (previous ?? previous.unitsAcquired), 0)

      if (this.minicart.appliedDiscount.discountID === 1 && this.minicart.appliedDiscount.unitsRequired > unitsAcquired) {
        return 0;
      }

      return this.minicart.discountAmount;
    }
  },
  created: function () {
    this.fetchInfo();

    const _self = this;

    window.addEventListener('cart:update', function (e) {
      _self.minicart = e.detail || null;
      if (_self.minicart) {
        _self.minicart.discountAmount = _self.calcDiscountAmount();
      }
      _self.totalNumberOfItems = _self.getTotalNumberOfItems();
    });
  }
};
</script>
